class ContentService {
	
	constructor($q, $sce, $http, $rootScope, InternalLinksService) {
		this.$q = $q;
		this.$sce = $sce;
		this.$http = $http;
		this.$rootScope = $rootScope;
		this.InternalLinksService = InternalLinksService;
	}

	/**
	 * Function for fetching content
	 * @param {string} contentUrl The content URL for the Pretor.Online
	 * @param {string} linksUrl The links URL for the Pretor.Online to get links
	 * @return {Promise<string>} The html content promise
	 */
	load(contentUrl, linksUrl) {
		const deferred = this.$q.defer();
		let loadLinksPromise;
		let url = this.InternalLinksService.getLink(contentUrl);

		if (!url) {
			loadLinksPromise = this.InternalLinksService.getLinks(linksUrl);
		} else {
			const linksDeferred = this.$q.defer();
			loadLinksPromise = linksDeferred.promise;
			linksDeferred.resolve();
		}

		loadLinksPromise.then(() => {
			if (!url) url = this.InternalLinksService.getLink(contentUrl);

			this.$http.get(url).then(
				(results) => {
					const content = results.hasOwnProperty('data') ? results.data : results;

					deferred.resolve(content);
				},
				(err) => {
					deferred.reject(err);
				}
			);
		});

		return deferred.promise;
	}

	generalLoad(url) {
		const deferred = this.$q.defer();
		const promise = deferred.promise;

		if (!url) {
			throw 'No URL was supplied.';
		}

		const headers = {
			'Access-Control-Allow-Origin': '*',
			responseType: 'arraybuffer'
		};

		this.$http({
			method: 'GET',
			url: url,
			headers: headers
		}).then(
			(results) => {
				const content = results.hasOwnProperty('data') ? results.data : results;
				deferred.resolve(content);
			},
			(err) => {
				deferred.reject(err);
			}
		);

		return promise;
	}
}
export default /* @ngInject */ ($q, $sce, $http, $rootScope, InternalLinksService) =>
	new ContentService($q, $sce, $http, $rootScope, InternalLinksService);
